<section class="section">
  <ul class="breadcrumb breadcrumb-style ">
    <li class="breadcrumb-item">
      <h4 class="page-title m-b-0">WhiteList my IP</h4>
    </li>
    <li class="breadcrumb-item">
      <a routerLink="/dashboard">
        <i data-feather="home"></i></a>
    </li>
    <li class="breadcrumb-item active">WhiteList my IP</li>
  </ul>


  <div class="section-body">
    <div class="row">
      <div class="col-12">
        <div class="card card-primary" style="border-top: 2px solid #3abaf4;">
          <div class="card-header">
            <h4>Allowed IP List</h4>
            <div class="card-header-action">
              <a data-toggle="collapse" class="btn btn-icon btn-info" href="#tableCollapse">
                <i class="fas fa-minus"></i></a>
            </div>
          </div>
          <div class="collapse show" id="tableCollapse">
            <div class="card-body">
              <div class="form-group row mb-4">
                <div class="col-sm-12 col-md-7">
                  <button type="submit" style="margin-right: 10px !important;background-color: #318ce7;"
                    class="btn btn-primary" (click)="addnewuser()"><i class="fas fa-plus-circle"></i>Add IP</button>
                  <!-- <button type="submit" style="margin-right: 10px !important;background-color: #318ce7;"
                    class="btn btn-primary" (click)="showmodal()"><i class="fas fa-plus-circle"></i>show modal</button> -->
                </div>
              </div>



              <div class="table-responsive">
                <table class="table table-striped">
                  <!-- id="tableExport" -->
                  <thead>
                    <tr style="text-align: center;">
                      <th style="background-color: #318ce7;">Customer Name</th>
                      <th style="background-color: #318ce7;">Short Name</th>
                      <th style="background-color: #318ce7;">Country</th>
                      <th style="background-color: #318ce7;">IP Address</th>
                      <th style="background-color: #318ce7;">Action</th>
                    </tr>
                  </thead>
                  <tbody style="text-align: center;">


                    <tr style="border-bottom: 1px solid #dbdada;" *ngFor="let allows of allowedList">
                      <td> {{allows.customer_name}}</td>
                      <td> {{allows.short_name}} </td>
                      <td> {{allows.country}} </td>
                      <td><span style="margin-right: 5px !important">
                          <div class="badge badge-default badge-shadow" style="margin-bottom: 7px;margin-top: 7px;font-weight: 700;
                              font-size: 14px;">&nbsp;{{allows.ip_data_from}}&nbsp; 
                              <span *ngIf="allows.temp == '1'" class="temparory-badge">Temp</span>
                          </div>
                        </span></td>

                      <td class="action-btn-group">

                        <!-- <a (click)="edituser(l.Userid)" data-toggle="tooltip" title="Edit"
                              class="btn btn-primary">
                              <i class="far fa-edit"></i>
                            </a> -->
                        <a (click)="deleteTheIP(allows.id,allows.server)" data-toggle="tooltip" title="Delete" class="btn btn-danger deleted-trash">
                          <i class="far fa-trash-alt"></i>
                        </a>

                      </td>

                    </tr>


                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




  <!-- ============== TABLE 2 -============= -->

  <div class="section-body">
    <div class="row">
      <div class="col-12">
        <div class="card card-primary" style="border-top: 2px solid #3abaf4;">
          <div class="card-header">
            <h4>Deleted IP List</h4>
            <div class="card-header-action">
              <a data-toggle="collapse" class="btn btn-icon btn-info" href="#tableCollapse2">
                <i class="fas fa-minus"></i></a>
            </div>
          </div>
          <div class="collapse show" id="tableCollapse2">
            <div class="card-body">
              <div class="form-group row mb-4">
                <!-- <div class="col-sm-12 col-md-7">
                  <button type="submit" style="margin-right: 10px !important" class="btn btn-primary"
                    (click)="addnewuser()"><i class="fas fa-plus-circle"></i>Add New User</button>
                </div> -->
              </div>

              <div class="table-responsive">
                <table class="table table-striped">
                  <!-- id="tableExport" -->
                  <thead>
                    <tr style="text-align: center;">
                      <th style="background-color: #318ce7;">Customer Name</th>
                      <th style="background-color: #318ce7;">Short Name</th>
                      <th style="background-color: #318ce7;">Country</th>
                      <th style="background-color: #318ce7;">IP Address</th>
                      <th style="background-color: #318ce7;">Action</th>
                    </tr>
                  </thead>
                  <tbody style="text-align: center;">


                    <tr *ngFor="let deleted of deletedList">
                      <td> {{deleted.customer_name}}</td>
                      <td> {{deleted.short_name}} </td>
                      <td> {{deleted.country}} </td>
                      <td><span style="margin-right: 5px !important">
                          <div class="badge badge-default badge-shadow" style="margin-bottom: 7px;margin-top: 7px;font-weight: 700;
                              font-size: 14px;">&nbsp;{{deleted.ip_data_from}}&nbsp;
                           <span *ngIf="deleted.temp == '1'" class="temparory-badge">Temp</span>
                          </div>
                        </span></td>

                      <td class="action-btn-group">

                        <a (click)="restoredIP(deleted)" data-toggle="tooltip" title="Delete" class="btn btn-danger" style="   box-shadow: 0 2px 6px #8edc9c;
                            background-color: #28a745;
                            border-color: #28a745;
                            width: 40px;
                            /* font-size: 15px; */
                            font-weight: 600;
                            font-size: 12px;
                            line-height: 24px;
                            padding: 0.3rem 0.8rem;
                            letter-spacing: .5px;
                            border-radius: 5px;
                            height: auto;">
                          <i class="fa fa-refresh" aria-hidden="true"></i>
                        </a>

                      </td>

                    </tr>
                    <!-- <tr>
                          <td> Voicetel Company Limited</td>
                          <td> Voicetel </td>
                          <td><span  style="margin-right: 5px !important">
                              <div class="badge badge-default badge-shadow" style="margin-bottom: 7px;margin-top: 7px;font-weight: 700;
                              font-size: 14px;"
                                >&nbsp;255.255.255.255&nbsp;
                              </div>
                            </span></td>
    
                          <td class="action-btn-group">
    
                            <a   data-toggle="tooltip" title="Delete"
                            class="btn btn-danger" style="   box-shadow: 0 2px 6px #8edc9c;
                            background-color: #28a745;
                            border-color: #28a745;
                            width: 40px;
                            /* font-size: 15px; */
                            font-weight: 600;
                            font-size: 12px;
                            line-height: 24px;
                            padding: 0.3rem 0.8rem;
                            letter-spacing: .5px;
                            border-radius: 5px;
                            height: auto;">
                            <i class="fa fa-refresh" aria-hidden="true"></i>
                          </a>
    
                          </td>
  
                        </tr> -->


                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>




<!-- ========================= CREATE POPUP ======================== -->

<div class="modal fade createticketModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
  aria-hidden="true" id="createipmodal">
  <div class="modal-dialog modal-sd">
    <div class="modal-content">
      <div class="modal-header" style="background-color:white !important;color: grey;padding-top: 28px;">
        <h5 class="modal-title" id="myLargeModalLabel">Add IP Address to Allowed Group</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">



        <form class="deal-register-form" [formGroup]="ipinformation">

          <div class="form-group">
            <label for="partner-name">Customer Name</label>
            <input type="text" class="form-control" id="partner-name" formControlName="customername" readonly>
            <div class="error-message message-small"
              *ngIf="!ipinformation.get('customername').valid && ipinformation.get('customername').touched">
              Please enter Customer Name
            </div>
          </div>

          <div class="form-group">
            <label for="partner-name">Tag Name</label>
            <input type="text" class="form-control" id="partner-name" formControlName="tagged_name" maxlength="5" (keypress)="keyPressAlphaNumeric($event)">
            <div class="error-message message-small"
              *ngIf="!ipinformation.get('tagged_name').valid && ipinformation.get('tagged_name').touched">
              Please enter Tag Name
            </div>
          </div>


          <div class="form-group">
            <label for="country-name">Country</label>
            <!-- <input type="text" class="form-control" id="country-name" formControlName="country" > -->
            <select id="country-name" name="country-name" class="optional form-control" formControlName="country">
              <!-- <option value="0" selected="selected">Please choose category</option> -->
              <option value="{{item.id}}" *ngFor="let item of countrylist">{{item.country}}</option>
            </select>
            <div class="error-message message-small"
              *ngIf="!ipinformation.get('country').valid && ipinformation.get('country').touched">
              Please Choose a Country
            </div>
          </div>


          <div class="form-group">
            <label for="partner-name">IPv4 IP Address</label>
            <input type="text" class="form-control" id="partner-name" formControlName="ipaddress">
            <!-- <input type="text"  class="form-control" id="partner-name" formControlName="ipaddress" minlength="7" maxlength="15" size="15" pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$"> -->
            <div class="error-message message-small"
              *ngIf="!ipinformation.get('ipaddress').valid && ipinformation.get('ipaddress').touched">
              Please enter IP Address (xxx.xxx.xxx.xxx)
            </div>
          </div>


          <div class="form-group">
            <div class="form-check form-switch">
              <input class="form-check-input checkboxes" type="checkbox" id="flexSwitchCheckDefault">
              <label class="form-check-label checkbox-label" for="flexSwitchCheckDefault">Temporary</label>
            </div>
          </div>

          <div class="btn-groups aligncenter">
            <a class="btn btn-success mr-3"  (click)="submitForm()">Submit</a>
            <!-- <a  class="btn btn-info" data-dismiss="modal">Cancel</a> -->
            <a class="btn btn-outline-primary" data-dismiss="modal">Cancel</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>